import { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { DeleteSharedNotesModal } from "@/components/modal/delete-shared-notes";
import { AddToCollectionModal } from "@/components/modal/add-to-collection";
import { MDSFadeBottom, MDSPanelContainer, AppearAnimator } from "@/mds";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { HomePageNotesList } from "./components/notes-list-page-list";
import { NotesListPageHeader } from "./components/notes-list-page-header";
import { TrackedEvent } from "@/domains/metrics";
import { trackEvent } from "@/domains/metrics";
import styled from "@emotion/styled";
import { NotesPageDragAndDrop } from "@/pages/notes/drag-and-drop";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { useAppStore } from "@/store";

interface NotesListPageProps {}

export const NotesListPage: FC<NotesListPageProps> = observer(() => {
  const page = useTabPageStore("notesListPage");
  const { store } = useAppStore();
  const isEmpty = page.hasNoItems;
  const filters = page.filters;
  page.useEffects();

  const [isDragging, setIsDragging] = useState(false);
  const isOnboardingFlowActive = store.onboarding.isActive;

  /**
   * Track views of the notes list page.
   */
  useEffect(() => {
    if (isOnboardingFlowActive) return;

    trackEvent(TrackedEvent.NotesView, {
      lens: filters.params.lens,
      sort_by: filters.params.sortBy,
    });
  }, [filters.params.lens, filters.params.sortBy, isOnboardingFlowActive]);

  return (
    <PageWrapper visible={page.subscriptionInitialized}>
      <AddToCollectionModal store={page.addToCollectionModal} />
      <DeleteSharedNotesModal store={page.deleteSharedNotesModal} />
      <ShareSheetModal store={page.shareSheetModal} />
      <NotesListPageHeader />
      <NotesPageDragAndDrop onDrag={setIsDragging} isEmpty={isEmpty}>
        <MDSPanelContainer>
          <HomePageNotesList isDragging={isDragging} />
          <MDSFadeBottom />
        </MDSPanelContainer>
      </NotesPageDragAndDrop>
    </PageWrapper>
  );
});

NotesListPage.displayName = "NotesListPage";

const PageWrapper = styled(AppearAnimator)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});
